import React from 'react'
import { useSelector } from 'react-redux'

import { Switch } from 'antd'
import { Dropdown } from 'primereact/dropdown'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'

import { isAdmin } from '../../../../util/profiles'

const Header = ({
  selectedReferencePeriod,
  referencePeriods,
  setSelectedReferencePeriod,
  globalFilterValue,
  onGlobalFilterChange,
  exportCSV,
  exportExcelData,
  history,
  actionsIsActive,
  setActionsIsActive
}) => {
  const currentUser = useSelector((state) => state.auth.auth)
  return (
    <Toolbar
      start={
        <React.Fragment>
          <div>
            <h2>
              <b>Lista Visitas</b>
            </h2>
            {currentUser && isAdmin(currentUser) && (
              <p>
                {actionsIsActive ? 'Visitas ativas' : 'Visitas inativas'}
                <Switch
                  style={{ marginLeft: 10 }}
                  checked={actionsIsActive}
                  onChange={() => setActionsIsActive(!actionsIsActive)}
                  className="mr-2"
                />
              </p>
            )}
          </div>
        </React.Fragment>
      }
      end={
        <React.Fragment>
          <span className="p-float-label">
            <Dropdown
              inputId="dd-city"
              value={selectedReferencePeriod}
              onChange={(e) => setSelectedReferencePeriod(e.value)}
              options={referencePeriods}
              optionLabel="description"
              className="w-full md:w-14rem"
            />
            <label htmlFor="dd-city">Selecione uma safra</label>
          </span>
          <div style={{ display: 'flex', marginLeft: 8 }}>
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search"> </InputIcon>
              <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Pesquisar" />
            </IconField>
            <Button
              style={{ marginLeft: '10px' }}
              type="button"
              className="p-button-success mr-2"
              icon="pi pi-file"
              rounded
              onClick={() => exportCSV(false)}
              data-pr-tooltip="CSV"
            />
            <Button
              type="button"
              className="p-button-success mr-2"
              icon="pi pi-file-excel"
              severity="success"
              rounded
              onClick={exportExcelData}
              data-pr-tooltip="XLS"
            />
            <Button icon="pi pi-plus" onClick={() => history.push(`/actions/create`)} />
          </div>
        </React.Fragment>
      }
    />
  )
}

export default Header
